import React from 'react';
import classNames from 'classnames';
import TooltipButton from '../../../TooltipButton/TooltipButton';
import DeviceChartYAxisTitleEditor from './DeviceChartYAxisTitleEditor';
import styles from './DeviceChartYAxisTitle.module.css';

function DeviceChartYAxisTitle({
  axisId,
  position,
  datasets,
  title,
  editable = false,
  tooltip = false,
  editor = false,
  onClick,
  onHover,
  onClose
}) {
  const defaultTitle =
    title ||
    datasets
      .filter(({ yAxisID }) => yAxisID === axisId)
      .map(({ label }) => label)
      .join(', ');

  const handleClick = () => {
    if (onClick) {
      onClick(axisId);
    }
  };
  const handleMouseEnter = () => {
    if (onHover) {
      onHover(axisId);
    }
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.editable]: editable,
        [styles.left]: position === 'left',
        [styles.right]: position === 'right'
      })}
    >
      <div className={styles.text} onMouseEnter={handleMouseEnter} onClick={handleClick}>
        {defaultTitle}
      </div>
      {editable && <div className={styles.tooltip}>{tooltip && <TooltipButton disabled />}</div>}
      {editor && (
        <div className={styles.editor}>
          <DeviceChartYAxisTitleEditor axisId={axisId} defaultValue={defaultTitle} onClose={onClose} />
        </div>
      )}
    </div>
  );
}

export default DeviceChartYAxisTitle;
